import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ToastModal from "../../components/ToastModal/ToastModal";
import PasswordInput from "../../components/PasswordInput/PasswordInput";

import {
  Container,
  Panel,
  Header,
  Title,
  Ornament,
  OrnLine,
  OrnDiamond,
  Subtitle,
  Form,
  Field,
  Label,
  SubmitButton,
  Note,
  Message,
  CloseButton,
  FieldError,
} from "./UpdatePasswordPageStyles";

export default function UpdatePasswordPage() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [error, setError] = useState("");
  const [toastMsg, setToastMsg] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    validate();
  }, [password, confirmPassword]);

  const validate = () => {
    let valid = true;
    setPasswordError("");
    setConfirmError("");

    if (password.length < 6) {
      setPasswordError("Parola trebuie să conțină minim 6 caractere.");
      valid = false;
    }

    if (confirmPassword && password !== confirmPassword) {
      setConfirmError("Parolele nu coincid.");
      valid = false;
    }

    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validate()) return;

    const token = searchParams.get("token");
    if (!token) {
      setError("Tokenul lipsește sau este invalid.");
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_GRAPHQL_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: `
            mutation resetPassword($token: String!, $newPassword: String!) {
              resetPassword(token: $token, newPassword: $newPassword) {
                message
              }
            }
          `,
          variables: { token, newPassword: password },
        }),
      });

      const result = await response.json();

      if (result.errors) {
        setError(result.errors[0].message || "Eroare necunoscută.");
      } else {
        setToastMsg("Parola a fost actualizată cu succes!");
      }
    } catch (err) {
      setError("Eroare de rețea sau server.");
    }
  };

  return (
    <Container>
      <CloseButton aria-label="Închide" onClick={() => navigate("/login")}>
        ×
      </CloseButton>

      <Panel>
        <Header>
          <Title>Parolă nouă</Title>
          <Ornament aria-hidden="true">
            <OrnLine />
            <OrnDiamond />
          </Ornament>
          <Subtitle>
            Introdu noua ta parolă și confirm-o pentru a finaliza procesul.
          </Subtitle>
        </Header>

        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>Parolă nouă *</Label>
            <PasswordInput
              name="newPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {passwordError && <FieldError>{passwordError}</FieldError>}
          </Field>

          <Field>
            <Label>Confirmă parola *</Label>
            <PasswordInput
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            {confirmError && <FieldError>{confirmError}</FieldError>}
          </Field>

          <SubmitButton type="submit">Actualizează parola</SubmitButton>

          {error && <Message>{error}</Message>}

          <Note>Toate câmpurile marcate cu * trebuie completate.</Note>
        </Form>
      </Panel>

      {toastMsg && (
        <ToastModal
          message={toastMsg}
          onClose={() => navigate("/login", { state: { scrollTo: "top" } })}
        />
      )}
    </Container>
  );
}
